module.exports = __webpack_public_path__ + "fonts/Lato-LightItalic.2404a6da.ttf";